module.exports = __webpack_public_path__ + "img/07.0a8296a2.jpg";